<template>
  <nav>
    <ul class="tgb-ul-reset tabs">
      <slot>
        <li
          v-for="(tab, index) in tabs"
          :key="index"
        >
          <button
            class="tabs__tab"
            :class="activeTab === index ? 'tabs__tab--active' : ''"
            type="button"
            role="tab"
            :aria-controls="tab.contentId"
            :data-entity="`producer-dashboard-${tab.key}`"
            @click="onClickTab(tab, index)"
          >
            {{ tab.title }}
          </button>
        </li>
      </slot>

      <slot name="tabAfterLast" />
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'Tabs',

  props: {
    activeTab: {
      type: Number,
      required: true,
      default: 0,
    },
  },

  data() {
    return {
      tabs: [
        {
          key: 'allProduction',
          title: 'All Productions',
          contentId: 'all',
        },
        {
          key: 'deletedProductions',
          title: 'Deleted Productions',
          contentId: 'deleted',
        },
      ],
    };
  },

  methods: {
    onClickTab(tab, index) {
      if (index !== this.activeTab) {
        this.$emit('tab-clicked', { tab, index });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs {
  position: relative;
  display: flex;
  grid-gap: 2rem;
  margin: 0 0 2rem;
  padding: 0;
  list-style: none;
}

.tabs__tab {
  padding: 0;
  background-color: transparent;
  border-width: 0;
  font-family: 'Barlow', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 1.5;
  color: #808689;

  &--active {
    font-weight: 700;
    color: #e1e1e1;

    &::after {
      display: block;
      width: 100%;
      height: 0.1875rem;
      content: '';
      background: #23cdf4;
      position: relative;
      bottom: -0.1875rem;
    }
  }
}
</style>
